import { render, staticRenderFns } from "./ProductModelCreator.vue?vue&type=template&id=a12e6796&scoped=true"
import script from "./ProductModelCreator.vue?vue&type=script&lang=js"
export * from "./ProductModelCreator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12e6796",
  null
  
)

export default component.exports